import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalComponent from "../modal";
import InputComponent from "../input";
import ButtonComponent from "../button";
import { useFormik } from "formik";
import { mccBlockSchema } from "../../helpers/schemas";
import TextareaComponent from "../textarea";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { ActionsContainer, CheckboxWrapper, EmptyWrapper, FieldContainer, FiltersWrapper, Form, FormError, FormWrapper, TableWrapper, TabsWrapper } from "./add-update-mcc-block-modal.style";
import FiltersComponent from "../filters";
import { BlockListSvg, ReloadSvg, SearchSvg } from "../../assets/svgs";
import TableComponent from "../table";
import moment from "moment";
import EmptyModalComponent from "../empty-modal";
import TabsComponent from "../tabs";
import { createMccTabsConstant, createMccTabsOptions } from "../../constants/app-constants";
import BadgeComponent from "../badge";
import SelectDropdownSecondaryComponent from "../select-dropdown-secondary";
import { getAllAvailableMccsList } from "../../redux/slices/mcc-block-slice";
import { providerInstitutionConstant } from "../../constants/user-constants";

const AddUpdateMccBlockModal = ({ data, close, label, handleFormSubmit, viewOnly, update, fromParticipantlevel, fromRemoveMcc, fromMakerChecker, slide }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { allAvailableMccCategories, allAvailableMccList } = useSelector((state) => state.mccBlockReducer);

    // const notProvider = (user?.institution?.id !== providerInstitutionConstant?.id) && (!user?.superAdmin);
    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);
    const isChecker = location.pathname.includes('checker');
    const isDisabledAll = isChecker || viewOnly || fromRemoveMcc;

    const initialSearch = {
        type: "",
        description: "",
        code: "",
    };

    const initialStates = {
        search: initialSearch,
        filteredData: allAvailableMccList || [],
        selectedTab: fromMakerChecker ? createMccTabsConstant.selected : createMccTabsConstant.all,
    };

    const [states, setStates] = useState(initialStates);

    const [hasChanges, setHasChanges] = useState(false);

    const { handleChange, handleBlur, handleSubmit, validateForm, setFieldValue, values, touched, errors, dirty } = useFormik({
        initialValues: data,
        validationSchema: mccBlockSchema({ fromParticipantlevel, fromMakerChecker }),
        onSubmit: fromMakerChecker ? () => { } : (payload) => {
            if (hasChanges) {
                const updatedMerchants = payload.merchants.map(({ isGloballyBlocked, isParticipantLevelBlocked, ...rest }) => rest);
                const updatedPayload = { ...payload, merchants: updatedMerchants };
                handleFormSubmit(updatedPayload);
            } else {
                toast.info('No changes found');
            }
        },
    });

    const isParticipantLevelCheck = (!fromParticipantlevel || (fromParticipantlevel && values?.institutionCode));

    const handleAcceptReject = async (isAccept) => {
        const formErrors = await validateForm();

        if (Object.keys(formErrors).length < 1) {
            const { reason, ...blockedMccRequest } = values;
            const institutionsName = institutionsWithID?.find((e) => e?.value === values?.institutionCode)?.label;
            handleFormSubmit({
                isaccepted: isAccept,
                blockedMccRequest: { ...blockedMccRequest, institutionCode: fromParticipantlevel ? { id: values?.institutionCode, descr: institutionsName } : null },
                reason,
            });
        } else {
            handleSubmit();
        }
    };

    const handleChangeFilters = (e) => {
        const { name, value, type, checked } = e.target
        setStates((old) => ({
            ...old,
            search: ({
                ...old.search,
                [name]: ['checkbox', 'radio'].includes(type) ? checked : value
            })
        }));
    };

    const handleResetFilters = () => {
        setStates((old) => ({
            ...old,
            search: initialSearch,
            filteredData: allAvailableMccList || [],
        }));
    };

    const handleFiltersSubmit = (e) => {
        e.preventDefault();
        const { search } = states;
        const filteredData = allAvailableMccList?.filter((item) => {
            return (
                (search.description ? item.description.toLowerCase().includes(search.description.toLowerCase()) : true) &&
                (search.code ? item.code.toString().includes(search.code.toString()) : true) &&
                (search.type ? item.type === search.type : true)
            );
        });
        setStates((old) => ({
            ...old,
            filteredData: filteredData,
            selectedTab: createMccTabsConstant.all,
        }));
    };

    const handleSelectMccs = (row) => {
        const isMerchantExists = values?.merchants.some((merchant) => merchant?.code === row?.code);
        const updatedMerchants = isMerchantExists
            ? values.merchants.filter((merchant) => merchant?.code !== row?.code)
            : [...values.merchants, row];
        setFieldValue('merchants', updatedMerchants);
    };

    useEffect(() => {
        setHasChanges(dirty);
    }, [dirty]);

    useEffect(() => {
        if (fromParticipantlevel && values?.institutionCode && values?.institutionCode !== '') {
            dispatch(getAllAvailableMccsList({ user, search: { institutionCode: values?.institutionCode } })).then((action) => {
                if ((action?.payload?.status === 201 || action?.payload?.status === 200) && !fromMakerChecker) {
                    setFieldValue('merchants', []);
                }
            });
        }
    }, [values?.institutionCode]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (allAvailableMccList && allAvailableMccList.length > 0) {
            setStates((old) => ({
                ...old,
                filteredData: allAvailableMccList,
            }));
        }
    }, [allAvailableMccList]);

    // useEffect(() => {
    //     if (allAvailableMccList && allAvailableMccList.length > 0) {
    //         const filteredData = allAvailableMccList?.filter((item) => {
    //             return (
    //                 (states.search.description ? item.description.toLowerCase().includes(states.search.description.toLowerCase()) : true) &&
    //                 (states.search.code ? item.code.toString().includes(states.search.code.toString()) : true) &&
    //                 (states.search.type ? item.type === states.search.type : true)
    //             );
    //         });
    //         setStates((old) => ({
    //             ...old,
    //             filteredData: filteredData,
    //         }));
    //     }
    // }, [allAvailableMccList, states.search]);

    const searchFields = [
        {
            label: 'Description',
            type: 'text',
            placeholder: 'Search by description',
            name: 'description',
            value: states.search.description,
        },
        {
            label: 'MCC Code',
            type: 'number',
            placeholder: 'Search by code',
            name: 'code',
            value: states.search.code,
        },
        {
            label: 'MCC Group',
            type: 'select',
            options: allAvailableMccCategories,
            name: 'type',
            value: states.search.type,
        },
        {
            type: 'action',
            actions: [
                { label: 'Reset', icon: ReloadSvg, type: 'button', outline: true, action: handleResetFilters },
                { label: 'Search', icon: SearchSvg, type: 'submit', action: () => { } }
            ],
        }
    ];

    const fields = [
        {
            label: 'Effective Date',
            type: 'datetime-local',
            placeholder: 'Set effective date',
            name: 'effectiveDate',
            value: values?.effectiveDate || '',
            min: moment().add(1, 'day').startOf('day').format().slice(0, 16),
            disabled: isDisabledAll,
        },
        ...(fromMakerChecker ? [{
            label: 'Comments',
            type: 'textarea',
            placeholder: 'Enter Comments',
            name: 'reason',
            value: values?.reason,
            fullCol: true,
        }] : []),
        {
            type: 'action',
            actions: fromMakerChecker ? [
                { label: 'Reject', type: 'button', color: 'error', outline: true, action: () => handleAcceptReject(false) },
                { label: isChecker ? 'Approve' : 'Resend', type: 'button', action: () => handleAcceptReject(true) }
            ] : [
                { label: viewOnly ? 'Close' : 'Cancel', type: 'button', outline: !viewOnly, action: close },
                ...(!viewOnly ? [{ label: update ? 'Update' : 'Block', type: 'submit' }] : [])
            ],
            fullCol: true,
        }
    ];

    // TABLE COLUMNS SETUP AS PER DATA
    const columns = [
        {
            field: 'action',
            headerName: 'Action',
            width: 60,
            align: 'center',
            valueGetter: (row) => {
                return (
                    <CheckboxWrapper>
                        <input
                            type='checkbox'
                            checked={row?.isGloballyBlocked || row?.isParticipantLevelBlocked || values?.merchants?.some((merchant) => merchant?.code === row?.code)}
                            onChange={() => handleSelectMccs(row)}
                            disabled={isDisabledAll || row?.isGloballyBlocked || row?.isParticipantLevelBlocked}
                        />
                    </CheckboxWrapper>
                )
            },
            sortBy: (row) => ((row?.isGloballyBlocked || row?.isParticipantLevelBlocked || values?.merchants?.some((merchant) => merchant?.code === row?.code)) ? 1 : 0),
        },
        ...((states.filteredData.some(item => item?.isGloballyBlocked === true || item?.isParticipantLevelBlocked === true) && states.selectedTab === createMccTabsConstant.all) ? [{
            field: 'status',
            headerName: 'Status',
            width: 120,
            align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.isGloballyBlocked ? (
                                <BadgeComponent label={`${fromParticipantlevel ? 'Globally' : ''} Blocked`} type="error" outline />
                            ) : (fromParticipantlevel && row?.isParticipantLevelBlocked) ? (
                                <BadgeComponent label="Blocked" type="error" />
                            ) : '—'
                        }
                    </>
                )
            },
            sortBy: (row) => (row?.isGloballyBlocked ? 1 : row?.isParticipantLevelBlocked ? 0 : -1),
        }] : []),
        { field: 'description', headerName: 'Description', width: 100 },
        { field: 'code', headerName: 'MCC Code', width: 100, align: 'center' },
        { field: 'type', headerName: 'MCC Group', width: 100 },
    ];

    return (
        <ModalComponent close={close} label={label} width={1000} slide={slide}>
            {/* MODAL BODY */}
            <FormWrapper>
                {/* INSTITUTION SELECTOR */}
                {
                    fromParticipantlevel &&
                    <FieldContainer>
                        {/* <Label>Institution</Label> */}
                        <SelectDropdownSecondaryComponent
                            label="Institution"
                            options={institutionsWithID}
                            name="institutionCode"
                            value={values.institutionCode}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isDisabledAll || update || !isProvider}
                            mui
                        />
                        {
                            touched.institutionCode && errors.institutionCode && (
                                <FormError>{errors.institutionCode}</FormError>
                            )
                        }
                    </FieldContainer>
                }

                {
                    !isParticipantLevelCheck &&
                    <EmptyWrapper>
                        <EmptyModalComponent text={isDisabledAll ? 'No merchants found!' : 'Please select institution first!'} />
                    </EmptyWrapper>
                }

                {/* FILTER */}
                {
                    (searchFields && searchFields.length > 0 && !isChecker) && isParticipantLevelCheck && !fromRemoveMcc && (
                        <FiltersWrapper>
                            <label>Filters</label>
                            <FiltersComponent open={true} searchFields={searchFields} handleChange={handleChangeFilters} handleSubmit={handleFiltersSubmit} cols={4} />
                        </FiltersWrapper>
                    )
                }

                {/* TABLE & EFFECTIVE DATE */}
                <Form onSubmit={handleSubmit}>
                    {
                        isParticipantLevelCheck && !fromRemoveMcc && (
                            <TabsWrapper>
                                <TabsComponent
                                    tabs={
                                        createMccTabsOptions.map((tab) => ({
                                            label: tab.label,
                                            value: tab.value,
                                            count: tab.value === createMccTabsConstant.all ? states.filteredData?.length : tab.value === createMccTabsConstant.selected ? values?.merchants?.length : undefined,
                                        }))
                                    }
                                    value={states.selectedTab}
                                    onChange={(value) => setStates((old) => ({ ...old, selectedTab: value }))}
                                >
                                    {
                                        states.selectedTab === createMccTabsConstant.all && (
                                            <TableWrapper>
                                                {
                                                    states.filteredData && states.filteredData.length > 0 ? (
                                                        <>
                                                            <TableComponent rows={states.filteredData} columns={columns} icon={BlockListSvg} responsive={false} />
                                                            {
                                                                touched?.merchants && errors?.merchants && (
                                                                    <FormError>{errors?.merchants}</FormError>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                        <EmptyWrapper>
                                                            <EmptyModalComponent text={isDisabledAll ? 'No MCC found!' : 'Need to filter by MCC group first or No MCC found!'} />
                                                            {
                                                                touched?.merchants && errors?.merchants && (
                                                                    <FormError>{errors?.merchants}</FormError>
                                                                )
                                                            }
                                                        </EmptyWrapper>
                                                    )
                                                }
                                            </TableWrapper>
                                        )
                                    }
                                    {
                                        states.selectedTab === createMccTabsConstant.selected && (
                                            <TableWrapper>
                                                {
                                                    values?.merchants && values?.merchants.length > 0 ? (
                                                        <>
                                                            <TableComponent rows={values?.merchants} columns={columns} icon={BlockListSvg} />
                                                            {
                                                                touched?.merchants && errors?.merchants && (
                                                                    <FormError>{errors?.merchants}</FormError>
                                                                )
                                                            }
                                                        </>
                                                    ) : (
                                                        <EmptyWrapper>
                                                            <EmptyModalComponent text='No MCC Selected!' />
                                                            {
                                                                touched?.merchants && errors?.merchants && (
                                                                    <FormError>{errors?.merchants}</FormError>
                                                                )
                                                            }
                                                        </EmptyWrapper>
                                                    )
                                                }
                                            </TableWrapper>
                                        )
                                    }
                                </TabsComponent>
                            </TabsWrapper>
                        )
                    }

                    {
                        fromRemoveMcc &&
                        <TableWrapper>
                            <TableComponent rows={values?.merchants} columns={columns} icon={BlockListSvg} />
                        </TableWrapper>
                    }

                    {
                        fields && fields.length > 0 && fields.map((field, index) => (
                            <Fragment key={index}>
                                {
                                    ['text', 'number', 'datetime-local'].includes(field.type) && !field.hide && isParticipantLevelCheck &&
                                    <FieldContainer $fullcol={field.fullCol}>
                                        {/* <Label>{field.label}</Label> */}
                                        <InputComponent
                                            type={field.type}
                                            label={field.label}
                                            placeholder={field.placeholder}
                                            onBlur={handleBlur}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            min={field.min}
                                            disabled={field.disabled}
                                            mui
                                        />
                                        {
                                            touched[field.name] && errors[field.name] && (
                                                <FormError>{errors[field.name]}</FormError>
                                            )
                                        }
                                    </FieldContainer>
                                }

                                {
                                    field.type === 'textarea' && !field.hide &&
                                    <FieldContainer $fullcol={field.fullCol}>
                                        {/* <Label>Comments</Label> */}
                                        <TextareaComponent
                                            label="Comments"
                                            placeholder={field.placeholder}
                                            onBlur={handleBlur}
                                            name={field.name}
                                            value={field.value}
                                            onChange={handleChange}
                                            disabled={field.disabled}
                                            mui
                                        />
                                        {
                                            touched[field.name] && errors[field.name] && (
                                                <FormError>{errors[field.name]}</FormError>
                                            )
                                        }
                                    </FieldContainer>
                                }

                                {
                                    field.type === 'action' && field.actions.length > 0 &&
                                    <FieldContainer $fullcol={field.fullCol}>
                                        <ActionsContainer>
                                            {
                                                field.actions.map((button, index) => (
                                                    <ButtonComponent key={index} label={button.label} type={button.type} outline={button.outline} color={button.color} onClick={button.action} />
                                                ))
                                            }
                                        </ActionsContainer>
                                    </FieldContainer>
                                }
                            </Fragment>
                        ))
                    }
                </Form>
            </FormWrapper>
        </ModalComponent>
    );
};

export default AddUpdateMccBlockModal;